module.exports = __webpack_public_path__ + "img/hr-brown-fluff-dry-11.06c9501f.png";